WiseMetering.Collection.Seus = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Seu,
    url: '/seus'
});
